import { DELETE_CLIENTS_FAILURE, DELETE_CLIENTS_SUCCESS } from "redux/constants/MyM"

const initState = { data: [], error: false, errorData: "", isLoading: true }

export default (state = initState, action) => {
    switch (action.type) {
        case DELETE_CLIENTS_SUCCESS:
            return {
                ...state, data: action.payload, isLoading: false
            }
        case DELETE_CLIENTS_FAILURE:
            return {
                ...state, errorData: action.payload, error: true, isLoading: false
            }
        default:
            return {
                ...state
            }
    }
}
